import axios from "axios";

export default function changePassword(form) {
  return axios.post("api/change-password", form);
}
